import { useSelector } from "react-redux";
import { apiRequest } from "./api";

// get Token
import useAuthToken from "../../Hooks/useAuthToken";

export const useUploadImageToB2 = () => {
  const token = useAuthToken();

  const uploadImageToB2 = async (file) => {
    console.log(file);
    if (!file) {
      throw new Error("Please provide a file");
    }

    const formData = new FormData();
    formData.append("image", file);
    return apiRequest("post", "/api/image-upload", formData, token, true);
  };

  return uploadImageToB2;
};
